<template>
  <div class="login">
    <div class="box-wrap">
      <div class="login-title">
        <div class="logo">
          <img src="../assets/images/logo.png" alt="" />
        </div>
        <div class="info">
          <div v-if="getSystem">
            系統日期：{{ formatDateTime('YYYY/MM/DD', getSystem?.date) }}
            <br />
            門市：{{ getSystem?.erp_id + ' ' + getSystem?.name }}
            <div class="d-flex" style="height: 35px; margin-top: 10px">
              <cus-button
                :text="'機台: ' + getSystem?.client_id"
                color="weekGreen"
                :isButton="false"
                :width="50"
                textClass="system-text"
                style="min-height: auto; margin: 0; padding-left: 0"
              ></cus-button>
              <cus-button
                :text="'班別: ' + getSystem?.section"
                color="weekGreen"
                :isButton="false"
                :width="50"
                textClass="system-text"
                style="min-height: auto; margin: 0; padding-right: 0"
              ></cus-button>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-top: 30px">
        <div class="form-item">
          <span>零用金</span>
          <div
            :class="['input-button', 'input-button-disabled', cash ? 'done' : '']"
            @click="openInput($event, 'inputCash')"
          >
            <p>{{ cash || '請輸入零用金' }}</p>
            <i data-action="cancel" v-if="cash" class="bi bi-x-circle-fill action-icon icon" @click="cash = ''"></i>
          </div>
        </div>
        <div class="form-item">
          <span>帳號</span>
          <cus-input v-model:value="account" placeholder="請輸入帳號" :errorText="errorText.account"></cus-input>
        </div>
        <div class="form-item">
          <span>密碼</span>
          <cus-input
            v-model:value="password"
            placeholder="請輸入密碼"
            :errorText="errorText.password"
            type="password"
          ></cus-input>
        </div>
      </div>
      <div class="d-flex" style="margin-top: 30px">
        <cus-button
          topIcon="power"
          topIconClass="middle-top"
          color="whiteBlue"
          :width="25"
          style="height: 60px"
          @click="handleShowShutdown(true)"
        ></cus-button>
        <cus-button
          text="登入"
          color="blue"
          :width="75"
          style="height: 60px"
          :disabled="!account || !password || isLoginLoading"
          @click="handleLogin"
        ></cus-button>
      </div>
      <small>version: {{ getVersion }}</small>
    </div>
  </div>

  <!-- 各式彈窗 -->
  <component :is="dialogTemplate"></component>
  <component :is="orderDialogTemplate"></component>
  <Shutdown v-if="isShowShutdownDialog" @close="handleShowShutdown(false)" />
</template>
<script>
import { ref, reactive, defineAsyncComponent, getCurrentInstance, watch } from 'vue';
import { useGetters, useMutations, useActions } from '@/utils/mapStore';
import { useRouter } from 'vue-router';
import { formatDateTime } from '@/utils/datetime';
import { useDialog } from '@/utils/dialog';
import { useOrderDialog } from '@/utils/manageOrderDialog';
import { useUpdateLoading } from '@/utils/updatePosData.js';
export default {
  name: 'login',
  components: {
    Computer: defineAsyncComponent(() => import('@/components/dialog/Computer.vue')),
    Shift: defineAsyncComponent(() => import('@/components/orderDialog/Shift.vue')),
    Accounting: defineAsyncComponent(() => import('@/components/orderDialog/Accounting.vue')),
    Shutdown: defineAsyncComponent(() => import('@/components/orderDialog/Shutdown.vue')),
  },
  setup() {
    const { getVersion, getEnvironment } = useGetters('system', ['getVersion', 'getEnvironment']);
    //使用彈窗
    const { proxy } = getCurrentInstance();
    const { dialogTemplate, openDialog, closeDialog } = useDialog();
    const router = useRouter();
    //建立參數
    const cash = ref('');
    const account = ref(getEnvironment.value === 'release' ? '' : 'test1');
    const password = ref(getEnvironment.value === 'release' ? '' : '111111');
    let isLoginLoading = ref(false);
    let errorText = reactive({
      account: '',
      password: '',
    });
    //取得系統版號和POS班號
    // const doGetDutySection = useActions('system', ['doGetDutySection']);
    const getSystem = useGetters('system', ['getSystem']);
    // const init = (async function () {
    //   await doGetDutySection();
    //   cash.value = getSystem.value.cash;
    // })();

    //取得商品資料更新狀態
    const checkPosDataStatus = useActions('updatePosData', ['checkPosDataStatus']);
    const getPosDataStatus = useGetters('updatePosData', ['getPosDataStatus']);
    const getUpdatePosDataStatus = async () => {
      await checkPosDataStatus();
      switch (getPosDataStatus.value) {
        case 0:
          // 更新完成
          break;
        case 98:
          // 更新異常
          break;
        default:
          // 更新中開啟進度條蓋板畫面
          if (!document.querySelector('#update-loading')) useUpdateLoading(true);
          break;
      }
    };
    getUpdatePosDataStatus();

    //打開彈窗
    const openInput = (e, type) => {
      if (e.target.getAttribute('data-action') === 'cancel') return;
      openDialog(type);
    };

    //輸入零用金
    const handleCash = (val) => {
      cash.value = Number(val);
      closeDialog();
    };

    //登入
    const doLogin = useActions('system', ['doLogin']);
    const SET_SHOW_SHIFT = useMutations('accounting', ['SET_SHOW_SHIFT']);
    const handleLogin = async () => {
      isLoginLoading.value = true;
      try {
        const res = await doLogin({ cash: cash.value, account: account.value, password: password.value });
        isLoginLoading.value = false;
        router.push('/order');
        if (res.show_alert_type === 1) {
          proxy
            .$confirm({
              content: `登出前未交班清帳，目前仍為${getSystem.value.section}班，是否執行交班清帳？`,
              confirmText: '交班清帳',
              cancelText: `維持${getSystem.value.section}班`,
            })
            .then(() => {
              SET_SHOW_SHIFT(true);
            })
            .catch((e) => {
              if (e == '取消' && res.box_alert === true) {
                proxy
                  .$message('加值中心服務提醒', res.box_alert_message, {
                    image: require('@/assets/images/icon-notice.png'),
                    confirmText: '確定',
                  })
                  .then(() => {});
              }
            });
        } else if (res.box_alert === true) {
          proxy
            .$message('加值中心服務提醒', res.box_alert_message, {
              image: require('@/assets/images/icon-notice.png'),
              confirmText: '確定',
            })
            .then(() => {});
        }
      } catch {
        isLoginLoading.value = false;
      }
    };

    //監聽是否要自動彈出交班清帳彈窗
    const { orderDialogTemplate, openOrderDialog } = useOrderDialog();
    const getShowShift = useGetters('accounting', ['getShowShift']);
    watch(getShowShift, () => {
      if (getShowShift.value) openOrderDialog('shift');
    });

    // 關閉系統
    let isShowShutdownDialog = ref(false);
    const handleShowShutdown = (value) => {
      isShowShutdownDialog.value = value;
    };

    return {
      getVersion,
      formatDateTime,
      dialogTemplate,
      openDialog,
      cash,
      account,
      password,
      isLoginLoading,
      errorText,
      getSystem,
      openInput,
      handleCash,
      handleLogin,
      isShowShutdownDialog,
      handleShowShutdown,
      orderDialogTemplate,
      getUpdatePosDataStatus,
    };
  },
};
</script>
<style lang="scss" scoped>
.login {
  width: 100%;
  height: 100vh;
  background: url(../assets/images/bg.jpg);
  background-size: cover;
  @include flex-center-center;
  .box-wrap {
    width: 520px;
    height: 580px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 6px 6px 10px 0 rgba(75, 96, 132, 0.44);
    color: $color-gray-70;
    letter-spacing: 1px;
    padding: 50px 70px;
  }
  .login-title {
    display: grid;
    grid-template-columns: 110px auto;
    align-items: center;
    img {
      width: 100%;
    }
    .info {
      @include flex-center-center;
      font-size: 2rem;
      font-weight: 500;
      line-height: 4rem;
      :deep(.system-text) {
        font-size: 2rem;
      }
    }
  }
  .form-item {
    display: grid;
    grid-template-columns: 100px auto;
    align-items: center;
    span {
      margin-bottom: 12px;
      font-size: 2rem;
      padding-left: 10px;
    }
  }
  .input-button {
    @include input-basic;
    position: relative;
    height: $input-height;
    color: $color-gray-60;
    cursor: pointer;
  }
  .done {
    color: $color-blue;
  }
  .icon {
    font-size: 2.2rem;
    color: $color-gray-30;
  }
}
</style>
